import { Component, Inject, OnInit } from "@angular/core";
import { CompanyService } from "./company.service";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { Observable } from "rxjs";
import Swal from "sweetalert2";

@Component({
  selector: "app-company",
  templateUrl: "./company.component.html",
  styleUrls: ["./company.component.scss"],
  imports: [CommonModule, RouterModule],
})
export class CompanyComponent implements OnInit {
  items$: Observable<any[]> | undefined;

  constructor(@Inject(CompanyService) public companyService: CompanyService) {}

  async ngOnInit() {
    await this.loadFirstPage();
  }

  async loadFirstPage() {
    this.items$ = this.companyService.getFirstPage();
  }

  async nextPage() {
    this.items$ = this.companyService.getNextPage();
  }

  async prevPage() {
    this.items$ = this.companyService.getPreviousPage();
  }

  formatGeo(item: any): string {
    const geo = item?.geolocalizacao;
    if (!geo || (geo.lat === 0 && geo.lng === 0)) {
      return "—";
    }
    return `${Number(geo.lat).toFixed(5)}, ${Number(geo.lng).toFixed(5)}`;
  }

  formatCnpj(cnpj: string): string {
    const digits = (cnpj ?? "").replace(/\D/g, "");
    if (digits.length === 14) {
      return digits.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
    }
    if (digits.length === 11) {
      return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    }
    return cnpj || "—";
  }

  isVisible(item: any): boolean {
    return this.companyService.isVisibleInApp(item);
  }

  async toggleStatus(item: any) {
    const currentlyActive = item?.status === 1;
    const nextStatus = currentlyActive ? 0 : 1;
    const action = currentlyActive ? "desativar" : "ativar";

    const result = await Swal.fire({
      title: `Deseja ${action} esta empresa?`,
      text: item?.nomeFantasia || "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Sim, ${action}`,
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      await this.companyService.updateStatus(item.id, nextStatus);
      await this.loadFirstPage();
      Swal.fire(
        "Pronto!",
        `Empresa ${currentlyActive ? "desativada" : "ativada"} com sucesso.`,
        "success"
      );
    } catch {
      Swal.fire("Erro!", "Não foi possível atualizar o status.", "error");
    }
  }
}
